__turbopack_context__.v({
  "accent": "chip-module-scss-module__EsJa8W__accent",
  "accent__disabled": "chip-module-scss-module__EsJa8W__accent__disabled",
  "accent__selected": "chip-module-scss-module__EsJa8W__accent__selected",
  "app_light_theme": "chip-module-scss-module__EsJa8W__app_light_theme",
  "closeIcon": "chip-module-scss-module__EsJa8W__closeIcon",
  "light": "chip-module-scss-module__EsJa8W__light",
  "light__disabled": "chip-module-scss-module__EsJa8W__light__disabled",
  "light__selected": "chip-module-scss-module__EsJa8W__light__selected",
  "outlined": "chip-module-scss-module__EsJa8W__outlined",
  "outlined__disabled": "chip-module-scss-module__EsJa8W__outlined__disabled",
  "outlined__selected": "chip-module-scss-module__EsJa8W__outlined__selected",
  "root": "chip-module-scss-module__EsJa8W__root",
});
